import { Component, OnInit } from '@angular/core'
import { SignupFlowService } from '@flowaccount/landing'
import { SignupPreviousPath } from '../../../../enum/landing-enum'
import { TranslateService } from '@ngx-translate/core'
@Component({
  selector: 'flowaccount-tax-invoice-join',
  templateUrl: './tax-invoice-join.component.html',
  styleUrls: ['./tax-invoice-join.component.scss'],
})
export class TaxInvoiceJoinComponent implements OnInit {
  constructor(public translate: TranslateService, private signupFlowService: SignupFlowService) {}

  ngOnInit(): void {}

  onSignupEvent(): void {
    this.signupFlowService.setCookie(SignupPreviousPath.TAX_INVOICE, true)
  }
}
